import { memo } from 'react'
// @ts-expect-error TS7016 -- MIGRATION: not approved, fix when encountered
import { PrimaryButton, TextEditor, SecondaryButton } from 'ui_kit_qmd'
import './NoteSectionItemTextCreator.scss'

const secondaryBtnContainerStyle = { height: 40, width: 104, padding: 0 }
const primaryBtnContainerStyle = { height: 40, width: 104, marginLeft: 16 }

const NoteSectionItemTextCreator = memo(
  ({
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    editorTitle,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    isError,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    setText,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    textEditorRef,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    setLocalError,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    localError,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    onCancelPress,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    onSavePress,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    enableHTML,
  }) => (
    <div className='note-item-creator-container'>
      <div className='note-item-creator-header'>
        <span className='note-item-creator-title'>{editorTitle}</span>
      </div>
      <TextEditor
        placeHolderText='Type something...'
        containerAdditionalClassName='note-item-creator-text-editor-container-additional'
        isError={isError}
        setText={setText}
        ref={textEditorRef}
        setDescriptionLocalError={setLocalError}
        descriptionLocalError={localError}
        enableHTML={enableHTML}
      />
      <div className='note-item-creator-button-container'>
        <SecondaryButton btnText='Cancel' containerStyle={secondaryBtnContainerStyle} onPress={onCancelPress} />
        <PrimaryButton btnText='Save' containerStyle={primaryBtnContainerStyle} onPress={onSavePress} />
      </div>
    </div>
  ),
)

export default NoteSectionItemTextCreator
